<script setup lang="ts">
import SeparatedDatetimepicker from 'frontend/common/ea-form-controls/separated-datetimepicker.vue'
import { ISearchCriteriaNode } from 'frontend/filters/types/ISearchCriteriaNode'
import { computed } from 'vue'
import { useStore } from 'vuex'

interface Props {
  modelValue: string | number
  criterion: ISearchCriteriaNode
  predicate: string
  label?: string
}
const props = defineProps<Props>()

interface Emits {
  (e: 'update:modelValue', value: string | number): void
}
const emit = defineEmits<Emits>()

const valueModel = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

const store = useStore()
</script>

<template>
  <SeparatedDatetimepicker
    v-model="valueModel"
    :label="props.label"
    :name="`nameToBeRenamed`"
    :type="criterion.type == 'string' ? 'text' : criterion.type"
    :time-zone="store.state.session.timeZone"
    skip-dirty-check
    input-size="sm"
    :clearable="false"
  />
</template>
